import { render, staticRenderFns } from "./ProjectCosting.vue?vue&type=template&id=1246ca3e&"
import script from "./ProjectCosting.vue?vue&type=script&lang=js&"
export * from "./ProjectCosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports